export default __webpack_public_path__ + "8c391d1c20bcb0a4fa73e0a139e4d0a3.png";